<template>
  <v-dialog :value="showDialog" @input="cancel()" width="800">
    <v-card id="editRate" flat>
      <v-app-bar dark flat color="primary">
        <v-btn icon dark @click="cancel()">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{
          resx.labels.qualifyVisit.toUpperCase()
        }}</v-toolbar-title>
      </v-app-bar>
      <form novalidate @submit.prevent.stop="save()">
        <v-card-text>
          <v-list-item class="tab">
            <v-list-item-action>
              <v-icon color="primary">perm_contact_calendar</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-subtitle>{{
                resx.labels.contractor
              }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-title>{{
              value &&
                value.contractorCompany &&
                value.contractorCompany.contractor.name
            }}</v-list-item-title>
            <div>
              <v-btn v-if="isHidden"
                v-on:click="isHidden = !isHidden"
              >
                {{ resx.labels.hideVisitors }}
              </v-btn>
              <v-btn v-else
                v-on:click="isHidden = !isHidden"
              >
                {{ resx.labels.showVisitors }}
              </v-btn>
            </div>

            <!-- TODO: "ver visitantes" -->
            <!-- selectedVisit && selectedVisit.contractorCompany.contractor.name) -->
          </v-list-item>
          <v-row>
            <v-divider></v-divider>
          </v-row>
          <v-tabs
            v-if="isHidden"
            :icons-and-text="$vuetify.breakpoint.smAndUp"
            centered
            grow
          >
            <v-tab href="#employees">
              <span v-if="$vuetify.breakpoint.smAndUp">{{
                resx.labels.employees
              }}</span>
              <v-icon>people</v-icon>
            </v-tab>
            <v-tab href="#vehicles">
              <span v-if="$vuetify.breakpoint.smAndUp">{{
                resx.labels.vehicles
              }}</span>
              <v-icon>commute</v-icon>
              <v-divider></v-divider>
            </v-tab>
            <v-tab-item
              value="employees"
              style="overflow-y: auto;"
            >
              <edit-rate-employees-details
                :visitEmployees="visitEmployees"
              ></edit-rate-employees-details>
            </v-tab-item>
            <v-tab-item
              value="vehicles"
              style="overflow-y: auto;"
            >
              <edit-rate-vehicles-details
                :visitVehicles="visitVehicles"
              ></edit-rate-vehicles-details>
            </v-tab-item>
          </v-tabs>
          <v-row row>
            <v-col xs3 class="mr-2">
              <datepicker-component
                :label="resx.labels.startDate"
                :no-clear="true"
                :max="maxDate"
                v-model="visitStartDate"
              />
            </v-col>
            <v-col xs3 class="ml-2">
              <time-picker
                :label="resx.labels.startTime"
                :no-clear="true"
                v-model="visitStartTime"
              />
            </v-col>
          </v-row>
          <v-row row>
            <v-col xs3 class="mr-2">
              <datepicker-component
                :no-clear="true"
                :label="resx.labels.endDate"
                :min="minDate"
                v-model="visitEndDate"
              />
            </v-col>
            <v-col xs3 class="ml-2">
              <time-picker
              v-if="this.value && this.value.closedAt != null"
                :no-clear="true"
                :label="resx.labels.endTime"
                :min="minTime"
                v-model="visitEndTime"
              />
              <time-picker v-else
                :label="resx.labels.endTime"
                class=""
                :readonly="true"
                v-model="resx.labels.visitInProgress"
              />
            </v-col>
            <v-col xs3 class="ml-2">
              <v-text-field
                :label="resx.labels.duration"
                class=""
                :readonly="true"
                v-model="duration"
              />
            </v-col>
          </v-row>
          <v-text-field
            v-model="motive"
            v-validate="'max:200'"
            name="motive"
            :label="resx.labels.motive"
            :data-vv-as="resx.labels.visitMotive"
            :error-messages="errors.collect('motive')"
            :counter="200"
          />
          <v-row row align-center mb-4>
            <v-col shrink>
              <span>{{ resx.labels.rateContractor }}</span>
            </v-col>
            <v-col class="ml-2">
              <star-rating
                :star-size="26"
                :padding="8"
                :show-rating="false"
                :rounded-corners="true"
                active-color="#4caf50"
                @rating-selected="rate = $event"
                v-if="showDialog"
              >
              </star-rating>
            </v-col>
          </v-row>
          <v-textarea
            v-model="comment"
            v-validate="'max:2000'"
            rows="5"
            name="comment"
            :label="resx.labels.comments"
            :placeholder="resx.messages.qualifyContractorCommentPlaceholder"
            :error-messages="errors.collect('comment')"
            :counter="2000"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click.prevent="cancel()">{{ resx.labels.cancel }}</v-btn>
          <v-btn
            color="success"
            type="submit"
            :disabled="!isValidForm || rate == 0"
            >{{ resx.labels.send }}</v-btn
          >
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
"use strict";

import moment from "moment";
import StarRating from "vue-star-rating";
import { EventBus } from "@/bus";
import contractorCompanyService from "@/services/ContractorCompanyService";
import editRateEmployeesDetails from "./edit-rate-employees-details.view.vue";
import editRateVehiclesDetails from "./edit-rate-vehicles-details.view.vue";
import datepickerComponent from "@/components/common/datepicker.vue";
import TimePicker from "@/components/common/timepicker.vue";

export default {
  name: "editRate",
  components: {
    StarRating,
    datepickerComponent,
    TimePicker,
    editRateEmployeesDetails,
    editRateVehiclesDetails
  },
  computed: {
    minDate() {
      return moment(this.visitStartDate).format("YYYY-MM-DD");
    },
    minTime() {
      if (!this.dateOfVisit) {
        return null;
      }
      const min = moment(this.dateOfVisit).format("HH:mm");
      return min;
    },
    maxDate() {
      return moment(this.endOfVisit).format("YYYY-MM-DD");
    },
    maxTime() {
      if (!this.endOfVisit) {
        return null;
      }
      const max = moment(this.endOfVisit).format("HH:mm");
      return max;
    },
    duration() {
      // Los cuatro campos arrancan en null y solo se completan dentro del
      // if (val) del watcher de `value`. Sin esta guarda se arma la cadena
      // "nullTnull", moment no la reconoce y cae al Date() del navegador: de
      // ahi salia el warning de deprecacion. El campo de al lado, en esta misma
      // fila del formulario, ya se protege con un v-if sobre `value`.
      if (
        !this.visitStartDate ||
        !this.visitStartTime ||
        !this.visitEndDate ||
        !this.visitEndTime
      ) {
        return null;
      }

      // Formato explicito: sin el, moment adivina y vuelve a caer al Date() del
      // navegador ante cualquier valor inesperado, que es lo que la propia
      // deprecacion avisa que va a dejar de funcionar.
      const FORMAT = "YYYY-MM-DDTHH:mm";
      const start = moment(this.visitStartDate + "T" + this.visitStartTime, FORMAT);
      const end = moment(this.visitEndDate + "T" + this.visitEndTime, FORMAT);
      if (!start.isValid() || !end.isValid()) {
        return null;
      }

      const timeDiff = end.diff(start);

      let hours = parseInt(moment.duration(timeDiff).asHours());
      let minutes = moment.duration(timeDiff).asMinutes() - (hours * 60);
      if (minutes < 10) minutes = '0' + minutes;
      return hours + ':' + minutes;
    },
    formatDuration() {
      if (this.duration) {
        return moment
          .utc(moment.duration(+this.duration, "minutes").asMilliseconds())
          .format("HH:mm");
      } else {
        return null;
      }
    }
  },
  data() {
    return {
      contractorCompany: null,
      motive: null,
      dateOfVisit: null,
      endOfVisit: null,
      visitStartTime: null,
      visitEndTime: null,
      closedAt: null,
      visitStartDate: null,
      visitEndDate: null,
      rate: 0,
      comment: null,
      showDialog: false,
      isHidden: null,
      state: null
    };
  },
  methods: {
    cancel() {
      this.showDialog = false;
      this.isHidden = false;
      this.$emit("cancel");
    },
    async save() {
      const rated = await contractorCompanyService.rateContractor(
        this.value.contractorCompany.contractor._id,
        this.value._id,
        this.rate,
        this.comment,
        this.motive,
        this.user,
        moment(this.visitStartDate + 'T' + this.visitStartTime),
      );
      await contractorCompanyService.updateVisit(
        this.value._id,
        "rated",
        this.value.hasRequestAccess
      );
      this.$store.commit("substractPendingRate", this.value._id);
      this.showDialog = false;
      this.isHidden = false;
      this.$emit("save", rated);
      EventBus.$emit("pendingRateSaved", rated);
    }
  },
  props: {
    value: { type: Object },
    visitEmployees: { type: Array },
    visitVehicles: { type: Array },
  },
  watch: {
    value: {
      handler: function(val) {
        if (val) {
          this.contractorCompany = val.contractorCompany;
        this.motive = null;
        this.visitStartDate =
          val && moment(val.dateOfVisit).format("YYYY-MM-DD");
        if (val && !val.endOfVisit) {
          this.visitEndDate = moment().format("YYYY-MM-DD");
        } else if (val) {
          this.visitEndDate =
            val && moment(val.endOfVisit).format("YYYY-MM-DD");
        };
        this.visitStartTime =
          val && moment(val.dateOfVisit).format("HH:mm");
        this.visitEndTime =
          val && moment(val.endOfVisit).format("HH:mm");
          this.rate = 0;
          this.comment = null;
          this.showDialog = val != null;
          this.visitEmployees = val.contractorCompany.employees.filter(employee => {
            for (const v of val.visitors) {
              if (v.employee == employee.id) {
                return true;
              }
            }
            return false;
          });
          this.visitVehicles = val.contractorCompany.vehicles.filter(vehicle => {
            for (const v of val.visitors) {
              if (v.vehicle == vehicle._id) {
                return true;
              }
            }
            return false;
          });
        }
        this.rate = 0;
        this.comment = null;
        this.showDialog = val != null;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
#editRate {
  textarea {
    resize: none;
  }

  .v-input--slider {
    .v-messages__message {
      font-size: 16px;
      transition: none !important;
    }
  }
}

.v-toolbar__content .v-toolbar__title {
  letter-spacing: 0px;
}

#editRate .v-list__tile__action {
  margin-left: 9px;
  min-width: 40px;
}

#editRate .v-list__tile__content {
  width: 120px;
}

#editRate .v-list__tile__title {
  height: 25px;
  line-height: 26px;
  left: -9px;
}

#editRate .v-list__tile {
  margin-top: -13px;
  padding: 0px;
}

#editRate .v-list {
  padding: 0px;
}

#editRate .v-list-item {
  padding: 0px;
}

#editRate .tab {
  padding-bottom: 12px;
}

#editRate .v-list-item__content {
  padding: 0px;
}
</style>
